export * from './corner-down-right-icon';
